<template>
  <div class="min-h-screen bg-gray-50">
    <!-- 复用Header组件 -->
    <Header />

    <!-- 主要内容 -->
    <div class="container mx-auto py-6">
      <!-- 面包屑导航 -->
      <div class="mb-6">
        <div class="flex items-center text-sm bg-white px-4 py-3 rounded-lg shadow-sm">
          <router-link to="/" class="text-gray-500 hover:text-blue-600">网站首页</router-link>
          <span class="mx-2 text-gray-400">/</span>
          <span class="text-blue-600 font-medium">{{ member ? member.companyNameCn : '企业详情' }}</span>
        </div>
      </div>

      <div class="flex justify-center">
        <!-- 企业详情内容区域 -->
        <div class="max-w-3xl w-full">
          <div class="bg-white p-6 md:p-8 rounded-lg shadow-sm">
            <!-- 加载状态 -->
            <div v-if="loading" class="flex justify-center items-center py-20">
              <div class="text-gray-500">加载中...</div>
            </div>

            <!-- 错误状态 -->
            <div v-else-if="error" class="flex justify-center items-center py-20">
              <div class="text-red-500">{{ error }}</div>
            </div>

            <!-- 企业详情内容 -->
            <div v-else-if="member" class="space-y-6">
              <!-- 企业名称 -->
              <h1 class="article-title">{{ member.companyNameCn }}</h1>

              <!-- 企业简介 -->
              <div class="article-content">
                <p v-if="member.companyIntroduction" v-html="member.companyIntroduction"></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <AppFooter />
  </div>
</template>

<script>
import Header from '../components/Header.vue'
import AppFooter from '../components/Footer.vue'
import { api } from '../api'
import { CURRENT_CONFIG } from '../api/config.js'
import { useHead } from '@unhead/vue'
import { ref } from 'vue'

export default {
  name: 'MemberDetail',
  components: {
    Header,
    AppFooter
  },
  props: {
    id: {
      type: [String, Number],
      required: true
    }
  },
  setup() {
    const pageTitle = ref('吉林省软件行业协会')
    useHead({
      title: pageTitle,
      meta: [{ property: 'og:title', content: pageTitle }]
    })
    return { pageTitle }
  },
  data() {
    return {
      member: null,
      loading: false,
      error: null,
      BASE_URL: CURRENT_CONFIG.BASE_URL
    }
  },
  mounted() {
    this.loadMemberDetail()
  },
  methods: {
    async loadMemberDetail() {
      this.loading = true
      this.error = null
      try {
          console.log(this.id)
        const member = await api.getMemberDetail(this.id)
        this.member = member
        this.pageTitle = member.companyNameCn || '吉林省软件行业协会'
      } catch (error) {
        // this.error = '加载企业详情失败: ' + error.message
        console.error('加载企业详情失败:', error)
      } finally {
        this.loading = false
      }
    },
    getFullImageUrl(path) {
      if (!path) return ''
      // 如果已经是完整链接(http开头)，直接返回
      if (path.startsWith('http')) return path
      // 否则拼接环境变量中的基地址
      return this.BASE_URL + path
    }
  }
}
</script>

<style scoped>
.article-title {
  font-size: 28px;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 16px;
  line-height: 1.3;
  text-align: center;
}

.article-meta {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 16px;
  padding: 16px 0;
  border-bottom: 1px solid #e2e8f0;
  margin-bottom: 24px;
  color: #64748b;
  font-size: 14px;
}

.article-content {
  font-size: 16px;
  line-height: 1.8;
  color: #374151;
}

.article-content p {
  margin-bottom: 20px;
}

.article-content h2 {
  font-size: 20px;
  font-weight: 600;
  color: #1e293b;
  margin-top: 32px;
  margin-bottom: 16px;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .article-title {
    font-size: 24px;
  }

  .article-content {
    font-size: 15px;
  }
}
</style>
